import React, { Component } from "react";
import { Divider, Select } from "antd";
import {
  getRedirectQueryParams,
  selectFilterFunction,
} from "../../Constants/Utilities";
import { AppStorageKeys, DeviceManagePaths } from "../../Constants/Constants";
import { BreadCrumbs } from "../Common/BreadCrumbs";
import SessionStorage from "../../Constants/SessionStorage";

const ENV_VARS_FE = SessionStorage.get(AppStorageKeys.envVars);

export default class ListDeviceMangement extends Component {
  constructor(props) {
    super(props);
    const { protocol, hostname } = window.location;
    this.deviceManageUrl =
      protocol + "//" + hostname + ":" + ENV_VARS_FE.DEVICE_MANAGE_PORT;
  }

  render() {
    const {
      providerData,
      providerDataLoading,
      selectedProvider,
      onProviderSelect,
      selectedProviderName,
      onParentActionClick,
      onActionClick,
      parentBread,
      deviceModelRecord,
      serviceProviderRecord,
    } = this.props;

    const redirectUrl = getRedirectQueryParams({
      path: DeviceManagePaths.device,
      part: selectedProviderName,
      prov: selectedProvider,
      model: deviceModelRecord?.modelId,
    });

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs
            headers={parentBread}
            onParentActionClick={
              deviceModelRecord
                ? onParentActionClick(null, null)
                : onActionClick(null, null)
            }
          />
        </div>

        <Divider className="divider" />

        {deviceModelRecord && (
          <div className="page-parent-title-container">
            <label>Device Model: {deviceModelRecord.modelNumber}</label>
          </div>
        )}

        {serviceProviderRecord ? (
          <div className="page-parent-title-container">
            <label>Service Provider: {selectedProviderName}</label>
          </div>
        ) : (
          <div className="search-add-container">
            <div className="search-container">
              <span className="search-label">Service Provider:</span>
              <Select
                showSearch
                allowClear
                value={selectedProvider}
                loading={providerDataLoading}
                disabled={providerDataLoading}
                onChange={onProviderSelect}
                filterOption={selectFilterFunction}
                style={{ minWidth: "200px", maxWidth: "250px" }}
                placeholder={
                  providerDataLoading
                    ? "Loading Service Providers..."
                    : "Select Service Provider"
                }
              >
                {providerData?.map((item) => (
                  <Select.Option
                    key={item.providerId}
                    title={item.providerName}
                  >
                    {item.providerName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
        )}

        {!selectedProvider ? (
          <div className="no-entity-warning">
            <div className="warning-label">
              Select any Service Provider to view Devices
            </div>
          </div>
        ) : (
          <iframe
            className="new-frame"
            title="Device Management"
            src={this.deviceManageUrl + "/login?" + redirectUrl}
          />
        )}
      </div>
    );
  }
}
